import React from 'react'
import PropTypes from 'prop-types'
import SelectDropdown from '../SelectDropdown'

export const SortOptionsDropdown = ({ items, defaultValue, queryKey, currentQuery, onChange }) => {
  if (!items) {
    return null
  }

  const selectedValue = currentQuery[queryKey] || defaultValue || ''

  return (
    <SelectDropdown
      id="sort-select"
      handleChange={(event) => onChange(event, 'sort', event.target.value)}
      options={items}
      value={selectedValue}
      labelText="Sortera på"
      size="tiny"
    />
  )
}

SortOptionsDropdown.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  queryKey: PropTypes.string.isRequired,
  currentQuery: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  defaultValue: PropTypes.string,
}

export default SortOptionsDropdown
